export const ORDERS_LIST_REQUEST = 'ORDERS_LIST_REQUEST'
export const ORDERS_LIST_SUCCESS = 'ORDERS_LIST_SUCCESS'
export const ORDERS_LIST_FAILURE = 'ORDERS_LIST_FAILURE'
export const GET_ORDER_ITEM_LIST_REQUEST = 'GET_ORDER_ITEM_LIST_REQUEST'
export const GET_ORDER_ITEM_LIST_SUCCESS = 'GET_ORDER_ITEM_LIST_SUCCESS'
export const GET_ORDER_ITEM_LIST_FAILURE = 'GET_ORDER_ITEM_LIST_FAILURE'
export const GET_ORDER_INFO_REQUEST = 'GET_ORDER_INFO_REQUEST'
export const GET_ORDER_INFO_SUCCESS = 'GET_ORDER_INFO_SUCCESS'
export const GET_ORDER_INFO_FAILURE = 'GET_ORDER_INFO_FAILURE'
export const GET_ORDER_ADDRESS_REQUEST = 'GET_ORDER_ADDRESS_REQUEST'
export const GET_ORDER_ADDRESS_SUCCESS = 'GET_ORDER_ADDRESS_SUCCESS'
export const GET_ORDER_ADDRESS_FAILURE = 'GET_ORDER_ADDRESS_FAILURE'
export const LIST_COUPONS_REQUEST = 'LIST_COUPONS_REQUEST'
export const LIST_COUPONS_SUCCESS = 'LIST_COUPONS_SUCCESS'
export const LIST_COUPONS_FAILURE = 'LIST_COUPONS_FAILURE'
export const GET_COUPON_PROCESS_REQUEST = 'GET_COUPON_PROCESS_REQUEST'
export const GET_COUPON_PROCESS_SUCCESS = 'GET_COUPON_PROCESS_SUCCESS'
export const GET_COUPON_PROCESS_FAILURE = 'GET_COUPON_PROCESS_FAILURE'
export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST'
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS'
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE'
export const ORDER_CREDIT_CARD_PAYMENT_REQUEST = 'ORDER_CREDIT_CARD_PAYMENT_REQUEST'
export const ORDER_CREDIT_CARD_PAYMENT_SUCCESS = 'ORDER_CREDIT_CARD_PAYMENT_SUCCESS'
export const ORDER_CREDIT_CARD_PAYMENT_FAILURE = 'ORDER_CREDIT_CARD_PAYMENT_FAILURE'
export const UPDATE_SHIPPING_CART_REQUEST = 'UPDATE_SHIPPING_CART_REQUEST'
export const UPDATE_SHIPPING_CART_SUCCESS = 'UPDATE_SHIPPING_CART_SUCCESS'
export const UPDATE_SHIPPING_CART_FAILURE = 'UPDATE_SHIPPING_CART_FAILURE'
export const GET_SHIPPING_CART_REQUEST = 'GET_SHIPPING_CART_REQUEST'
export const GET_SHIPPING_CART_SUCCESS = 'GET_SHIPPING_CART_SUCCESS'
export const GET_SHIPPING_CART_FAILURE = 'GET_SHIPPING_CART_FAILURE'
export const CREATE_SHIPPING_ORDER_REQUEST = 'CREATE_SHIPPING_ORDER_REQUEST'
export const CREATE_SHIPPING_ORDER_SUCCESS = 'CREATE_SHIPPING_ORDER_SUCCESS'
export const CREATE_SHIPPING_ORDER_FAILURE = 'CREATE_SHIPPING_ORDER_FAILURE'
export const GET_FEE_REQUEST = 'GET_FEE_REQUEST'
export const GET_FEE_SUCCESS = 'GET_FEE_SUCCESS'
export const GET_FEE_FAILURE = 'GET_FEE_FAILURE'
export const INBOUND_ORDER_LIST_REQUEST = 'INBOUND_ORDER_LIST_REQUEST'
export const INBOUND_ORDER_LIST_SUCCESS = 'INBOUND_ORDER_LIST_SUCCESS'
export const INBOUND_ORDER_LIST_FAILURE = 'INBOUND_ORDER_LIST_FAILURE'
export const ORDER_CREDIT_CART_PAYMENT_REQUEST = 'ORDER_CREDIT_CART_PAYMENT_REQUEST'
export const ORDER_CREDIT_CART_PAYMENT_SUCCESS = 'ORDER_CREDIT_CART_PAYMENT_SUCCESS'
export const ORDER_CREDIT_CART_PAYMENT_FAILURE = 'ORDER_CREDIT_CART_PAYMENT_FAILURE'
export const CLEAN_SHIPPING_DATA = 'CLEAN_SHIPPING_DATA'
export const SAVE_SHIPPING_DATA = 'SAVE_SHIPPING_DATA'
export const CLEAN_ORDER_CREDIT_CART_PAYMENT_RESULT = 'CLEAN_ORDER_CREDIT_CART_PAYMENT_RESULT'
export const CHANG_ROUTE = 'CHANG_ROUTE'
export const CLEAN_ACTION = 'CLEAN_ACTION'

export const ordersListReq = payload => ({
    type: ORDERS_LIST_REQUEST,
    payload
})

export const ordersListSuccess = payload => ({
    type: ORDERS_LIST_SUCCESS,
    payload
})

export const ordersListFailure = payload => ({
    type: ORDERS_LIST_FAILURE,
    payload
})

export const getInboundOrdersListReq = payload => ({
    type: INBOUND_ORDER_LIST_REQUEST,
    payload
})

export const getInboundOrdersListSuccess = payload => ({
    type: INBOUND_ORDER_LIST_SUCCESS,
    payload
})

export const getInboundOrdersListFailure = payload => ({
    type: INBOUND_ORDER_LIST_FAILURE,
    payload
})

export const getOrderItemListReq = payload => ({
    type: GET_ORDER_ITEM_LIST_REQUEST,
    payload
})

export const getOrderItemListSuccess = payload => ({
    type: GET_ORDER_ITEM_LIST_SUCCESS,
    payload
})

export const getOrderItemListFailure = payload => ({
    type: GET_ORDER_ITEM_LIST_FAILURE,
    payload
})

export const getOrderInfoReq = payload => ({
    type: GET_ORDER_INFO_REQUEST,
    payload
})

export const getOrderInfoSuccess = payload => ({
    type: GET_ORDER_INFO_SUCCESS,
    payload
})

export const getOrderInfoFailure = payload => ({
    type: GET_ORDER_INFO_FAILURE,
    payload
})

export const getOrderAddressReq = payload => ({
    type: GET_ORDER_ADDRESS_REQUEST,
    payload
})

export const getOrderAddressSuccess = payload => ({
    type: GET_ORDER_ADDRESS_SUCCESS,
    payload
})

export const getOrderAddressFailure = payload => ({
    type: GET_ORDER_ADDRESS_FAILURE,
    payload
})

export const listCouponsReq = payload => ({
    type: LIST_COUPONS_REQUEST,
    payload
})

export const listCouponsSuccess = payload => ({
    type: LIST_COUPONS_SUCCESS,
    payload
})

export const listCouponsFailure = payload => ({
    type: LIST_COUPONS_FAILURE,
    payload
})

export const getCouponProcessReq = payload => ({
    type: GET_COUPON_PROCESS_REQUEST,
    payload
})

export const getCouponProcessSuccess = payload => ({
    type: GET_COUPON_PROCESS_SUCCESS,
    payload
})

export const getCouponProcessFailure = payload => ({
    type: GET_COUPON_PROCESS_FAILURE,
    payload
})

export const updateOrderReq = payload => ({
    type: UPDATE_ORDER_REQUEST,
    payload
})

export const updateOrderSuccess = payload => ({
    type: UPDATE_ORDER_SUCCESS,
    payload
})

export const updateOrderFailure = payload => ({
    type: UPDATE_ORDER_FAILURE,
    payload
})

export const orderCreditCardPaymentReq = payload => ({
    type: ORDER_CREDIT_CART_PAYMENT_REQUEST,
    payload
})

export const orderCreditCardPaymentSuccess = payload => ({
    type: ORDER_CREDIT_CART_PAYMENT_SUCCESS,
    payload
})

export const orderCreditCardPaymentFailure = payload => ({
    type: ORDER_CREDIT_CART_PAYMENT_FAILURE,
    payload
})

export const cleanOrderCreditCardPaymentResult = () => ({
    type: CLEAN_ORDER_CREDIT_CART_PAYMENT_RESULT,
})

export const updateShippingCartReq = payload => ({
    type: UPDATE_SHIPPING_CART_REQUEST,
    payload
})

export const updateShippingCartSuccess = payload => ({
    type: UPDATE_SHIPPING_CART_SUCCESS,
    payload
})

export const updateShippingCartFailure = payload => ({
    type: UPDATE_SHIPPING_CART_FAILURE,
    payload
})

export const getShippingCartReq = payload => ({
    type: GET_SHIPPING_CART_REQUEST,
    payload
})

export const getShippingCartSuccess = payload => ({
    type: GET_SHIPPING_CART_SUCCESS,
    payload
})

export const getShippingCartFailure = payload => ({
    type: GET_SHIPPING_CART_FAILURE,
    payload
})

export const createShippingOrderReq = payload => ({
    type: CREATE_SHIPPING_ORDER_REQUEST,
    payload
})

export const createShippingOrderSuccess = payload => ({
    type: CREATE_SHIPPING_ORDER_SUCCESS,
    payload
})

export const createShippingOrderFailure = payload => ({
    type: CREATE_SHIPPING_ORDER_FAILURE,
    payload
})

export const getFeeReq = payload => ({
    type: GET_FEE_REQUEST,
    payload
})

export const getFeeSuccess = payload => ({
    type: GET_FEE_SUCCESS,
    payload
})

export const getFeeFailure = payload => ({
    type: GET_FEE_FAILURE,
    payload
})

export const cleanShippingOrderData = payload => ({
    type: CLEAN_SHIPPING_DATA,
    payload
})

export const saveShippingOrderData = payload => ({
    type: SAVE_SHIPPING_DATA,
    payload
})

export const changeRoute = payload => ({
    type: CHANG_ROUTE,
    payload
})

export const cleanAction = cleanedKeys => ({
    type: CLEAN_ACTION,
    cleanedKeys
})